import React from 'react';
import Reflux from 'reflux';
import i18 from '../../../i18';
import {customerRuleApi} from '../../../api';
import RuleViewModal from '../rules/RuleViewModal';
import AssignmentRuleCreate from './AssignmentRuleCreate';

class Assignment extends Reflux.Component {

    constructor(props) {
        super(props);

        this.state = {
            showProcessedItems: false,
            showRule: null,
            savingRule: false,
        };
    }

    getCompanyId = () => {
        return this.props.config.company_id;
    };

    createRule = async (rule) => {
        if (this.state.savingRule) {
            return;
        }

        this.setState({
            savingRule: true,
        });

        try {
            const data = await customerRuleApi.create(
                this.getCompanyId(),
                rule,
            );

            this.props.notifySuccess(
                'A szabály sikeresen mentve.',
            );

            this.props.updateRules(
                data.customerRules || [],
            );
        } catch (error) {
            if (
                error
                && error.response
                && error.response.status === 422
            ) {
                const responseData = error.response.data;

                this.props.notifyError(
                    responseData && responseData.message
                        ? responseData.message
                        : 'A megadott adatok hibásak.',
                );

                return;
            }

            this.props.notifyError(
                'Hiba történt a szabály létrehozása során. (#1002)',
            );
        } finally {
            this.setState({
                savingRule: false,
            });
        }
    };

    showHideProcessedItems = () => {
        this.setState((previousState) => ({
            showProcessedItems:
                !previousState.showProcessedItems,
        }));
    };

    onShowRule = (rule) => {
        this.setState({
            showRule: rule,
        });
    };

    closeModal = () => {
        this.setState({
            showRule: null,
        });
    };

    findRule = (ruleId) => {
        return (this.props.customerRules || []).find(
            (rule) => (
                String(rule.id) === String(ruleId)
            ),
        ) || null;
    };

    getUnprocessedItems = () => {
        const items = [];

        (this.props.invoices || []).forEach(
            (invoice) => {
                (invoice.items || []).forEach(
                    (invoiceItem) => {
                        if (invoiceItem.rule_id) {
                            return;
                        }

                        items.push({
                            invoice,
                            invoiceItem,
                        });
                    },
                );
            },
        );

        return items;
    };

    getProcessedItems = () => {
        const items = [];

        (this.props.invoices || []).forEach(
            (invoice) => {
                (invoice.items || []).forEach(
                    (invoiceItem) => {
                        if (!invoiceItem.rule_id) {
                            return;
                        }

                        const rule = this.findRule(
                            invoiceItem.rule_id,
                        );

                        /*
                         * Előfordulhat, hogy az invoiceItem még egy már
                         * törölt szabály azonosítóját tartalmazza.
                         */
                        if (!rule) {
                            return;
                        }

                        items.push({
                            invoice,
                            invoiceItem,
                            rule,
                        });
                    },
                );
            },
        );

        return items;
    };

    renderListHeaderRow = () => {
        return (
            <tr>
                <th>{i18.CUSTOMER._invoiceNumber}</th>

                <th>{i18.CUSTOMER._typeOfTraffic}</th>
                <th>{i18.CUSTOMER._taxNumber}</th>
                <th>{i18.CUSTOMER._companyName}</th>
                <th>{i18.CUSTOMER._paymentType}</th>
                <th>{i18.CUSTOMER._positionNumber}</th>
                <th>{i18.CUSTOMER._positionNumberCountry}</th>
                <th>{i18.CUSTOMER._orderNumberStat}</th>

                <th>{i18.CUSTOMER._mainBookNumber}</th>
                <th>{i18.CUSTOMER._VAT}</th>
                <th>{i18.CUSTOMER._collectorCode}</th>
                <th>{i18.CUSTOMER._vatDegreeNumber}</th>
                <th>{i18.COMPANY._operations}</th>
            </tr>
        );
    };

    renderProcessedTableHeader = () => {
        return (
            <tr>
                <th>{i18.COMPANY._operations}</th>
                <th>{i18.CUSTOMER._invoiceNumber}</th>

                <th>{i18.CUSTOMER._typeOfTraffic}</th>
                <th>{i18.CUSTOMER._taxNumber}</th>
                <th>{i18.CUSTOMER._companyName}</th>
                <th>{i18.CUSTOMER._paymentType}</th>
                <th>{i18.CUSTOMER._positionNumber}</th>
                <th>{i18.CUSTOMER._positionNumberCountry}</th>
                <th>{i18.CUSTOMER._orderNumberStat}</th>

                <th>{i18.CUSTOMER._mainBookNumber}</th>
                <th>{i18.CUSTOMER._VAT}</th>
                <th>{i18.CUSTOMER._collectorCode}</th>
                <th>{i18.CUSTOMER._vatDegreeNumber}</th>
            </tr>
        );
    };

    renderProcessedTableRow = (processedItem) => {
        const {
            invoice,
            invoiceItem,
            rule,
        } = processedItem;

        const collectorCode = rule.vatCollectorCode
            ? rule.vatCollectorCode.code
            : null;

        return (
            <tr
                key={`processed-${invoiceItem._internalId}`}
            >
                <td>
                    <button
                        type="button"
                        className="table-green-btn"
                        onClick={() => this.onShowRule(rule)}
                    >
                        #{invoiceItem.rule_id}
                    </button>
                </td>

                <td>{invoice.invoiceNumber}</td>
                <td>{invoiceItem.name}</td>

                <td>{invoice.tax_number}</td>
                <td>{invoice.company_name}</td>
                <td>{invoice.paymentMethodLabel}</td>
                <td>{invoice.positionNumber}</td>
                <td>{invoice.positionNumberCountry}</td>
                <td>{invoice.orderNumberStat}</td>

                <td>{rule.main_bookkeeping_number}</td>
                <td>{parseInt(invoiceItem.vat, 10)}%</td>
                <td>{collectorCode}</td>
                <td>{rule.vat_degree}</td>
            </tr>
        );
    };

    renderUnprocessedRows = () => {
        const {
            config,
            vatCollectorCodes,
            notifySuccess,
            notifyError,
        } = this.props;

        return this.getUnprocessedItems().map(
            (unprocessedItem) => {
                const {
                    invoice,
                    invoiceItem,
                } = unprocessedItem;

                return (
                    <AssignmentRuleCreate
                        key={`unprocessed-${invoiceItem._internalId}`}
                        config={config}
                        vatCollectorCodes={vatCollectorCodes}
                        invoice={invoice}
                        invoiceItem={invoiceItem}
                        createRule={this.createRule}
                        notifySuccess={notifySuccess}
                        notifyError={notifyError}
                    />
                );
            },
        );
    };

    renderProcessedRows = () => {
        return this.getProcessedItems().map(
            this.renderProcessedTableRow,
        );
    };

    render() {
        const {
            config,
            nextStep,
        } = this.props;

        const {
            showProcessedItems,
            showRule,
            savingRule,
        } = this.state;

        return (
            <section
                id="customer-assignment"
                className="margin-bottom-50"
            >
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <table className="table table-striped table-aibook-no-border">
                                <thead>
                                {this.renderListHeaderRow()}
                                </thead>

                                <tbody>
                                {this.renderUnprocessedRows()}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="row margin-bottom-50">
                        <div className="col-12">
                            <div className="next-step-btn-container">
                                <button
                                    type="button"
                                    onClick={nextStep}
                                    className="next-step pull-right"
                                    disabled={savingRule}
                                >
                                    Feldolgozás
                                </button>

                                <button
                                    type="button"
                                    onClick={
                                        this.showHideProcessedItems
                                    }
                                    className="next-step pull-left"
                                >
                                    Feldolgozott tételek
                                </button>
                            </div>
                        </div>
                    </div>

                    <div
                        className={
                            showProcessedItems
                                ? ''
                                : 'd-none'
                        }
                    >
                        <table className="table table-striped table-aibook-no-border">
                            <thead>
                            {this.renderProcessedTableHeader()}
                            </thead>

                            <tbody>
                            {this.renderProcessedRows()}
                            </tbody>
                        </table>
                    </div>
                </div>

                {showRule
                    ? (
                        <RuleViewModal
                            config={config}
                            rule={showRule}
                            closeModal={this.closeModal}
                        />
                    )
                    : null}
            </section>
        );
    }
}

export default Assignment;


// WEBPACK FOOTER //
// ./src/components/customer/steps/Assignment.js